import * as z from 'zod'

import { SupportedMarketKey } from '@nxt-insurance/constants'

import location from '@flows/configs/common/steps/location'
import type { ContentsNeoStepConfigParams } from '@flows/configs/contents/types'
import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as stepUtils from '@flows/configs/shared/stepUtils'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_ContentsPremiumBasicNeodigitalDe } from '@flows/insurance/schemas'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  const zipCodeError = schemaUtils.zipCodeErrorMap(issue)
  return zipCodeError ?? { message: ctx.defaultError }
}

const contents_location = (params: ContentsNeoStepConfigParams) => {
  const locationStep = location({ market: SupportedMarketKey.De })

  return {
    schema: z.preprocess(
      (values) => {
        if (stepUtils.hasHouseNumber(values)) {
          return {
            ...values,
            house_no: values.houseNumber,
          }
        }
        return values
      },
      BaseSchema_ContentsPremiumBasicNeodigitalDe.pick({
        // We also pass houseNumber and validate it since some components use this name
        // TODO: [INFRA-4] remove this and use the correct name in clients
        house_no: true,
      }).merge(locationStep.schema)
    ),
    errorMap: getErrorMap(),
    stepContent: locationStep.stepContent,
    subFlow: params.subFlow,
    nextStep: 'contents_quote',
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'maybeFetchPrices',
        options: {
          // We currently need this flag to fetch the price every time
          // Fetching the price is the only way to validate the address for natural disasters
          forceFetchPrice: true,
        },
        inputs: [],
        outputs: [],
      },
    },
  } as const satisfies AnyStepConfiguration
}

export default contents_location
